/* eslint-disable import/order */
/* eslint-disable comma-dangle */
import {
    DealTypeEnum,
    RealtyObjectEnum,
    AreaUnitEnum,
    BathroomEnum,
    WallsTypeEnum,
    RenovationTypeEnum,
} from './schema-types-fix';
import { RenovationType } from '../enums/offer/RenovationType';
import { BathroomType } from '../enums/offer/BathroomType';
import {
    WallsType,
    AreaUnit,
    DealType,
    RealtyObjectType,
} from '../enums';

/** DealType */
export const dealTypeMapGraphQLDealTypeEnum: Record<DealType, DealTypeEnum> = {
    [DealType.SELL]: DealTypeEnum.Sell,
    [DealType.RENT]: DealTypeEnum.Rent,
    [DealType.UNKNOWN]: DealTypeEnum.Unknown
};

/** RealtyObject */
export const realtyObjectTypeMapGraphQLRealtyObjectEnum: Record<RealtyObjectType, RealtyObjectEnum> = {
    [RealtyObjectType.UNKNOWN]: RealtyObjectEnum.Unknown,
    [RealtyObjectType.FLAT]: RealtyObjectEnum.Flat,
    [RealtyObjectType.ROOM]: RealtyObjectEnum.Room,
    [RealtyObjectType.HOUSE]: RealtyObjectEnum.House,
    [RealtyObjectType.LAND]: RealtyObjectEnum.Land,
    [RealtyObjectType.COUNTRY_ESTATE]: RealtyObjectEnum.CountryEstate,
};

export const areaUnitEnumMapGraphQLAreaUnit: Record<AreaUnitEnum, AreaUnit> = {
    [AreaUnitEnum.Unknown]: AreaUnit.UNKNOWN,
    [AreaUnitEnum.Hectare]: AreaUnit.HECTARE,
    [AreaUnitEnum.Are]: AreaUnit.ARE,
    [AreaUnitEnum.Meter]: AreaUnit.METER
};

export const renovationTypeEnumMapRenovationType: Record<RenovationTypeEnum, RenovationType> = {
    [RenovationTypeEnum.Unknown]: RenovationType.UNKNOWN,
    [RenovationTypeEnum.Design]: RenovationType.DESIGN,
    [RenovationTypeEnum.Euro]: RenovationType.EURO,
    [RenovationTypeEnum.Need]: RenovationType.NEED,
    [RenovationTypeEnum.Good]: RenovationType.GOOD,
    [RenovationTypeEnum.Partial]: RenovationType.PARTIAL,
    [RenovationTypeEnum.PreFine]: RenovationType.PRE_FINE,
    [RenovationTypeEnum.Fine]: RenovationType.FINE,
    [RenovationTypeEnum.Rough]: RenovationType.ROUGH
};

export const bathroomEnumMapGraphQLBathroomType: Record<Exclude<BathroomEnum, BathroomEnum.Several>, BathroomType> = {
    [BathroomEnum.Combined]: BathroomType.COMBINED,
    [BathroomEnum.Parted]: BathroomType.PARTED,
    [BathroomEnum.Unknown]: BathroomType.UNKNOWN
};

export const wallsTypeEnumMapGraphQLWallsType: Record<WallsTypeEnum, WallsType> = {
    [WallsTypeEnum.Monolith]: WallsType.MONOLITH,
    [WallsTypeEnum.BrickMonolith]: WallsType.BRICK_MONOLITH,
    [WallsTypeEnum.Brick]: WallsType.BRICK,
    [WallsTypeEnum.Panel]: WallsType.PANEL,
    [WallsTypeEnum.Block]: WallsType.BLOCK,
    [WallsTypeEnum.Wood]: WallsType.WOOD,
    [WallsTypeEnum.Unknown]: WallsType.UNKNOWN
};
